// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"BackDrop_Backdrop__2zRLh"};